import { render, staticRenderFns } from "./recyclertAddEdit.vue?vue&type=template&id=3698fbb4&scoped=true&"
import script from "./recyclertAddEdit.vue?vue&type=script&lang=js&"
export * from "./recyclertAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./recyclertAddEdit.vue?vue&type=style&index=0&id=3698fbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698fbb4",
  null
  
)

export default component.exports